<template>
  <div class="arquivo">
    <div class="comments">
      <h3>{{ translate.commentBox }}</h3>
      <div v-if="commentsAll">
        <swiper
          :slidesPerView="1"
          :spaceBetween="20"
          :pagination="{ dynamicBullets: true, clickable: true }"
          :breakpoints="{
            '769': {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            '1300': {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }"
          :modules="modules"
          class="mySwiperComments"
          style="
            --swiper-pagination-color: black;
            --swiper-pagination-bullet-inactive-color: black;
            --swiper-pagination-bullet-size: 12px;
            --swiper-pagination-bottom: 0px;
          "
        >
          <swiper-slide v-for="(comment, index) in commentsAll" :key="index">
            <div class="comment-body mt-3">
              <div class="cabecalho mb-2">
                <img
                  v-if="comment.ativo == 'true'"
                  :src="comment.gold == 'true' ? IconeBdsGold : IconeBds"
                  :class="{ 'icone-gold': comment.gold == 'true' }"
                  :alt="comment.gold == 'true' ? 'Assinante Gold' : 'Assinante'"
                  :title="
                    comment.gold == 'true' ? 'Assinante Gold' : 'Assinante'
                  "
                />
                <strong class="name">{{
                  comment.user.nickname ?? comment.user.name
                }}</strong>
                {{ translate.wroteOn }} {{ comment.date }}:
              </div>
              <div
                v-if="summary"
                :class="{ 'texto-gold': comment.gold == 'true' }"
              >
                <!-- Texto em <span v-html> (links reconstruídos por
                     renderCommentHtml) para não conflitar com o "ver mais". -->
                <span
                  v-html="renderCommentHtml(comment.comment.slice(0, 300))"
                ></span>
                <a
                  href="#"
                  class="read"
                  v-if="comment.comment.length > 300"
                  @click.prevent="summary = false"
                  >... {{ translate.seeMoreComment }}</a
                >
              </div>
              <div v-else :class="{ 'texto-gold': comment.gold == 'true' }">
                <span v-html="renderCommentHtml(comment.comment)"></span>
                <a
                  href="#"
                  class="read"
                  v-if="comment.comment.length > 300"
                  @click.prevent="summary = true"
                  >... {{ translate.seeLessComment }}</a
                >
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import IconeBds from "@/assets/img/icone_BDS.png";
import IconeBdsGold from "@/assets/img/icone-bds-gold.png";
import api from "@/api";
import { renderCommentHtml } from "@/shared/utils/commentHtml";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// import required modules
import { Pagination } from "swiper/modules";
import { useCookies } from "vue3-cookies";
defineProps(["translate"]);
const { cookies } = useCookies();
const commentsAll = ref<any>([]);
const modules = [Pagination];
const summary = ref(true);

async function getComments() {
  api
    .get("v1/blog/getCommentsAllBlogs", {
      headers: {
        "X-Custom-Data": cookies.isKey("commentUser")
          ? cookies.get("commentUser")
          : "",
      },
    })
    .then(({ data }) => {
      commentsAll.value = data.comments;
    });
}

onMounted(() => {
  getComments();
});
</script>
<style scoped lang="css">
.swiper {
  width: 100%;
}

.swiper-slide {
  min-height: 120px;
}
.swiper-wrapper {
  margin-bottom: 30px;
}

h3 {
  color: #000000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  text-align: start;
  margin-top: 10px;
}

.arquivo {
  margin-top: 50px;
}

.arquivo div.comments {
  border: 1px solid #dfdfdf;
  padding: 18px;
  padding-left: 20px;
}

.arquivo div.comments img {
  width: 12px;
  margin-right: 5px;
  object-fit: cover;
}

/* Assinante Gold: ícone maior para dar ênfase ao comentário. */
.arquivo div.comments img.icone-gold {
  width: 12px;
  height: auto;
  vertical-align: -3px;
}

.name {
  color: black;
  font-size: small;
}

.comment-body {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

/* Assinante Gold: texto do comentário em negrito. */
.comment-body .texto-gold {
  font-family: "Roboto-Bold";
}

/* Links do comentário (gerados via v-html, daí o :deep). O .read ("ver mais")
   é excluído por ser um <a> do próprio template, com estilo próprio. */
.comment-body :deep(a:not(.read)) {
  color: #b20000;
  text-decoration: underline;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.read {
  font-family: "Roboto-Regular";
  color: #444444;
  font-size: 13px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .swiper {
    min-height: 165px !important;    
  }
}
</style>
